import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

export const useJob = (onDone, onTick) => {
  const [job, setJob] = useState(null);
  const timer = useRef(null);
  const doneRef = useRef(onDone);
  const tickRef = useRef(onTick);
  doneRef.current = onDone;
  tickRef.current = onTick;

  useEffect(() => {
    if (!job || ["completato", "errore"].includes(job.status)) return;
    timer.current = setTimeout(async () => {
      const { data } = await api.get(`/admin/jobs/${job.id}`).catch(() => ({ data: job }));
      tickRef.current?.(data, job);
      setJob(data);
      if (data.status === "completato") doneRef.current?.(data);
    }, 2000);
    return () => clearTimeout(timer.current);
  }, [job]);

  const retry = async () => { const { data } = await api.post(`/admin/jobs/${job.id}/retry`); setJob(data); };
  const running = job && !["completato", "errore"].includes(job.status);
  return { job, setJob, retry, running };
};

export const JobProgress = ({ job, onRetry, label, testId }) => {
  if (!job) return null;
  if (job.status === "errore") return (
    <div data-testid={`${testId}-error`} className="flex flex-wrap items-center gap-3 p-3 border border-[#8a2f22]/30 bg-[#8a2f22]/5 text-sm text-[#8a2f22]">
      <span className="flex-1">Errore: {job.error}</span>
      <button data-testid={`${testId}-retry`} onClick={onRetry} className="underline text-xs uppercase tracking-widest">Riprova</button>
    </div>
  );
  if (job.status === "completato") return null;
  return (
    <div data-testid={`${testId}-progress`} className="space-y-1.5">
      <div className="flex justify-between text-xs text-[#956842]"><span>{label} · {job.status.replace("_", " ")}</span><span>{job.progress}%</span></div>
      <div className="h-1 bg-[#D5B98C]/40 overflow-hidden"><div className="h-full bg-[#956842] transition-[width] duration-700" style={{ width: `${Math.max(job.progress, 6)}%` }} /></div>
    </div>
  );
};
